import React from "react";

function TotalRating() {
    return (
        <div className="md:w-full rounded-lg sticky top-0 mt-3 md:block hidden" style={{ color: "rgb(217, 119, 6" }}>
            <div className="w-full p-3 rounded-lg sticky top-40" style={{ background: "#f7f5f0" }}>
                <p className="text-base font-semibold mb-3">Lưu ý khi đánh giá</p>
                <ol>
                    <li>1. Không được dẫn link hoặc nhắc đến website khác</li>
                    <li>2. Không được có những từ ngữ gay gắt, đả kích, xúc phạm người khác</li>
                    <li>3. Đánh giá hoặc bình luận không liên quan tới truyện sẽ bị xóa</li>
                    <li>4. Đánh giá hoặc bình luận chê truyện một cách chung chung không mang lại giá trị cho người đọc sẽ bị xóa</li>
                    <li>5. Đánh giá có điểm số sai lệch với nội dung sẽ bị xóa</li>
                </ol>
                <div className="italic mt-2">Vui lòng xem và tuân theo đầy đủ các quy định tại Điều Khoản Dịch Vụ khi sử dụng website</div>
            </div>
        </div>
    );
}

export default TotalRating;
